export function showHidden () {
    let noscriptHidden = document.querySelectorAll('.noscript-hidden');

    for (let i = 0; i < noscriptHidden.length; i++) {
        noscriptHidden[i].classList.remove('noscript-hidden');
    }
}
